import { BREAKPOINT } from '@/constants';

/**
 * レスポンシブ画像の sizes 属性を生成する
 * @example
 * getImageLayoutSizes({ sp: '95vw', pc: '780px' })
 * // => '(max-width: 800px) 95vw, 780px'
 */
export const getImageLayoutSizes = (rules: { sp: string; pc: string }): string => {
  const { sp, pc } = rules;
  return [`(max-width: ${BREAKPOINT.SP}px) ${sp}`, pc].join(', ');
};
